import React, { memo } from 'react';
import './App.scss';
import { GlobalProvider } from 'shared/context/store';
import { ToastContainer } from 'react-toastify';
import ConnectedIntlProvider from './utils/ConnectedIntlProvider';
import Routes from './routes';
import 'react-toastify/dist/ReactToastify.css';

const App: React.FC = (): JSX.Element => (
  <GlobalProvider>
    <ConnectedIntlProvider>
      <Routes />
      <ToastContainer />
    </ConnectedIntlProvider>
  </GlobalProvider>
);

export default memo(App);
